export default function ServicesController(
  $scope,
  $stateParams,
  $window,
  servicesService,
  UtilService,
  NotificationService,
  sortableHelper,
  SERVICE_STATUSES,
) {
  var vm = this;

  vm.merchantId = $stateParams.merchantId;
  vm.serviceStatuses = SERVICE_STATUSES;
  vm.isLoading = false;
  vm.services = [];
  vm.statusPerCategory = [];

  vm.serviceListOptions = {
    updated: false,
    update: function() {
      this.updated = true;
    },
    stop: function(event, ui) {
      if (this.updated) {
        updateSortOrder(event, ui);
        this.updated = false;
      }
    },
    start: function() {
      sortableHelper.adjustTop(this);
    },
  };

  vm.init = init;
  vm.toggleStatus = toggleStatus;
  vm.deleteService = deleteService;
  vm.updateStatuses = updateStatuses;
  vm.updateStatusForCategory = updateStatusForCategory;

  var listener = $scope.$on('merchant.tab.services.selected', vm.init);

  function init() {
    if (!vm.isLoading) {
      getServices();
    }
  }

  function getServices() {
    listener();
    enableLoading();
    servicesService
      .getServices(vm.merchantId)
      .then(initServices)
      .catch(function() {
        NotificationService.error('Error getting merchant menu');
      })
      .finally(disableLoading);
  }

  function initServices(res) {
    if (res && res.data) {
      vm.services = res.data.map(function(servicesPerCategory) {
        servicesPerCategory.services.map(function(service) {
          service.isActive = service.status === SERVICE_STATUSES.ACTIVE;
        });
        return servicesPerCategory;
      });
      initToggleAllStatus();
    }
  }

  function initToggleAllStatus() {
    vm.statusPerCategory = [];
    vm.services.forEach(function(servicesPerCategory) {
      vm.statusPerCategory[servicesPerCategory.id] = false;
      servicesPerCategory.services.forEach(function(service) {
        if (service.isActive) {
          vm.statusPerCategory[servicesPerCategory.id] = true;
        }
      });
    });
  }

  function updateStatusForCategory(categoryId) {
    var servicesPerCategory = UtilService.findElementById(vm.services, categoryId);
    servicesPerCategory.services.forEach(function(service) {
      service.isActive = vm.statusPerCategory[categoryId];
    });
    updateStatuses(servicesPerCategory.serviceId, servicesPerCategory.services);
  }

  function updateStatuses(serviceId, services) {
    var updatedServices = angular.copy(services);
    if (vm.isLoading) {
      return;
    }
    enableLoading();
    updatedServices.forEach(function(service) {
      if (service.isActive) {
        service.status = SERVICE_STATUSES.ACTIVE;
      } else {
        service.status = SERVICE_STATUSES.INACTIVE;
      }
      delete service.isActive;
    });
    servicesService
      .updateServiceStatuses(vm.merchantId, serviceId, updatedServices)
      .then(function() {
        NotificationService.success('Menu item statuses updated');
      })
      .catch(function() {
        NotificationService.error('Error updating statuses.');
      })
      .finally(disableLoading);
  }

  function toggleStatus(serviceId, serviceItem) {
    updateStatuses(serviceId, [serviceItem]);
  }

  function deleteService(serviceId) {
    if (vm.isLoading) {
      return;
    }
    if ($window.confirm('Are you sure you want to delete this menu item?')) {
      enableLoading();
      servicesService
        .deleteService(vm.merchantId, serviceId)
        .then(function() {
          NotificationService.success('Menu item deleted');
          vm.services = [];
          getServices();
        })
        .finally(disableLoading);
    }
  }

  function updateSortOrder(event, ui) {
    var serviceItemId, newPosition;
    if (ui.item && ui.item.length && ui.item[0].id) {
      serviceItemId = parseInt(ui.item[0].id, 10);
      vm.services.some(function(servicesPerCategory) {
        newPosition = UtilService.findElementPositionById(servicesPerCategory.services, serviceItemId);
        if (newPosition >= 0) {
          enableLoading();
          servicesService
            .updateSortOrder(vm.merchantId, serviceItemId, newPosition)
            .then(function() {
              NotificationService.success('Menu sort order updated');
            })
            .catch(function() {
              NotificationService.error('Error updating sort order. Please refresh the page and try again.');
            })
            .finally(disableLoading);
          return true;
        }
      });
    }
  }

  function enableLoading() {
    vm.isLoading = true;
  }

  function disableLoading() {
    vm.isLoading = false;
  }
}



// WEBPACK FOOTER //
// ./src/app/merchants/services/services.controller.js